import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { getActiveTenantId } from "@/shared/tenant/active-tenant";
import type { CampaignAnalytics } from "./types";

/** GET /api/campaigns/{id}/analytics — per-step + total engagement (unique enrollments). */
export function useCampaignAnalytics(campaignId: string) {
  return useQuery({
    queryKey: ["analytics", getActiveTenantId(), campaignId] as const,
    queryFn: () => httpClient<CampaignAnalytics>(`/api/campaigns/${campaignId}/analytics`),
    enabled: !!campaignId,
  });
}
